import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InviteUsersComponent } from './invite-users.component';
import { KngLoaderModule, ModalModule, KngButtonModule } from 'kinetic-angular';
import { KngUploadFileModule } from 'projects/kinetic-angular/src/lib/components/upload-file';
import { ToastrModule } from 'ngx-toastr';
import { InviteUsersService } from './invite-users.service';
import { CommonModule } from '@angular/common';
@NgModule({
	declarations: [
		InviteUsersComponent
	],
	imports: [ 
		CommonModule,
		FormsModule,
		KngButtonModule,
		ReactiveFormsModule,
		ModalModule,
		KngLoaderModule,
		KngUploadFileModule,
		ToastrModule.forRoot({
			timeOut: 3000,
			positionClass: 'toast-top-right',
			toastClass: 'kng-toast toast-container ngx-toastr',
			enableHtml: true,
			closeButton: true,
			tapToDismiss: true,
			preventDuplicates: true
		})
	],
	exports: [
		InviteUsersComponent
	],
	providers: [
		InviteUsersService
	]
})
export class InviteUserModule {}
